import React from 'react';
import cn from 'classnames';
import { EmailIcon } from "../../../../../../ui/Icon";
import BodyText from "../../../../../../ui/Typography/texts/BodyText";
import MetaText from "../../../../../../ui/Typography/texts/MetaText";
import styles from './NotifyIfBackDropdown.module.scss';
const NotifyIfBackDropdown = ({ className, value, valueInfo, toggleNIBModal }) => {
    if (!value) {
        return null;
    }
    return (React.createElement("div", { className: cn(styles.container, className) },
        valueInfo && (React.createElement(MetaText, { Tag: "p", className: cn(styles.valueInfo) }, valueInfo)),
        React.createElement("button", { type: "button", onClick: toggleNIBModal, className: cn(styles.button, styles.value) },
            React.createElement(EmailIcon, null),
            React.createElement(BodyText, { Tag: "span" }, value))));
};
export default NotifyIfBackDropdown;
//# sourceMappingURL=NotifyIfBackDropdown.js.map